module.exports = __webpack_public_path__ + "static/media/fr-andrew.61731994.jpg";